const constructUrl = (url, path, width) => {
  const quality = '90,0';
  if (url.indexOf('[IMAGEFILEPATH]') > 0) {
    const imgUrl = url
      .replace(/\[IMAGEFILEPATH]/gi, path)
      .replace(/\[WIDTH]/gi, width)
      .replace(/\[QUALITY]/gi, quality);
    return imgUrl;
  }
  return url + path;
};
export default constructUrl;
